<template>
  <Day day="22.12.2025">
    <div slot="page-content">
      <h3>Double Pack</h3>
      <p>
        <img src="@/assets/day21.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day22',
  components: {
    Day
  }
}
</script>
